const actions = {
  SET_STATE: 'settings/SET_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
  SET_THEME: 'settings/SET_THEME',
  SET_LOCALE: 'settings/SET_LOCALE',
  RELOAD_SETTINGS: 'settings/RELOAD_SETTINGS',
  UPLOAD_SETTINGS: 'settings/UPLOAD_SETTINGS',
}

export default actions
